import type { PictogramName } from '@sola/schema/lib/pictograms.ts';

import { cn } from '../../utils/helpers.ts';

const defaultSize = 56;

export type PictogramProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  name: PictogramName;
  alt?: string;
  size?: number;
};

export const Pictogram = ({
  name,
  alt,
  size = defaultSize,
  style,
  className,
  ...props
}: PictogramProps) => {
  return (
    <img
      className={cn('Pictogram', className)}
      {...props}
      src={`/pictograms/${name}.svg`}
      alt={alt ?? ''}
      width={size}
      height={size}
      style={{ display: 'block', ...style }}
    />
  );
};
